import React from 'react'
import { Grid } from '@mui/material'
import {
  PublicPageLayout,
  getNextLevelLogoProps,
} from '@/housefolios-components/PublicPages/shared'
import { usePublicTeam } from '@/hooks/usePublicPages'
import TeamMemberCard from '@/housefolios-components/PublicPages/components/TeamMemberCard'

const PublicTeamPage = (props) => {
  const { orgId, marketplace } = props
  const { loading, error, teamMembers } = usePublicTeam(orgId)
  const { logoSrc, logoAlt } = getNextLevelLogoProps(marketplace)

  return (
    <PublicPageLayout
      title="Meet the Team"
      description="The team of experts that find the properties"
      icon={logoSrc ? undefined : ['fas', 'user-group']}
      logoSrc={logoSrc}
      logoAlt={logoAlt}
      loading={loading}
      error={error}
      containerProps={{
        style: { paddingLeft: '30px', paddingRight: '30px' },
      }}
    >
      {teamMembers.map((teamMember) => (
        <Grid key={teamMember._id} size={12}>
          <TeamMemberCard teamMember={teamMember} />
        </Grid>
      ))}
    </PublicPageLayout>
  );
}

export default PublicTeamPage
